import React from 'react';

interface ErrorMessageProps {
  /** Messaggio di errore da mostrare */
  message: string;
  /** Dettagli aggiuntivi (opzionale) */
  details?: string;
  /** Tipo di errore che influenza lo stile */
  type?: 'error' | 'warning' | 'info';
  /** Funzione di callback per azione (es. riprova) */
  onAction?: () => void;
  /** Testo del pulsante di azione */
  actionText?: string;
  /** Classe CSS personalizzata */
  className?: string;
  /** Se mostrare l'icona */
  showIcon?: boolean;
}

/**
 * Componente ErrorMessage riutilizzabile
 * Mostra messaggi di errore, avvertimento o informazioni standardizzati
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  details,
  type = 'error',
  onAction,
  actionText = 'Riprova',
  className = '',
  showIcon = true
}) => {
  const getIcon = () => {
    switch (type) {
      case 'error':
        return '⚠️';
      case 'warning':
        return '⚡';
      case 'info':
        return 'ℹ️';
      default:
        return '⚠️';
    }
  };

  const getTypeClass = () => {
    switch (type) {
      case 'error':
        return 'error-message';
      case 'warning':
        return 'warning-message';
      case 'info':
        return 'info-message';
      default:
        return 'error-message';
    }
  };

  return (
    <div className={`message-container ${getTypeClass()} ${className}`} 
         role="alert" 
         aria-live="polite">
      <div className="message-content">
        {showIcon && <span className="message-icon" aria-hidden="true">{getIcon()}</span>}
        <div className="message-text">
          <p className="message-primary">{message}</p>
          {details && <p className="message-details">{details}</p>}
        </div>
      </div>
      
      {onAction && (
        <div className="message-actions">
          <button 
            className="btn-secondary btn-small"
            onClick={onAction}
            type="button"
          >
            {actionText}
          </button>
        </div>
      )}
    </div>
  );
};

export default ErrorMessage;